import React from 'react';
import {
  StockLocationRole,
  StockLocationRoleAssignment,
} from '../types/stock_location_role_assignment/stockLocationRoleAssignment';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface StockLocationRoleAssignmentContextProps {
  // By stock location id
  stockLocationRoles: Map<string, StockLocationRoleAssignment[]>;
  setStockLocationRoles: (stockLocationRoles: Map<string, StockLocationRoleAssignment[]>) => void;
  stockLocationRolesLoading: boolean;
  refreshStockLocationRoles: (companyId: string) => Promise<void>;
  currentStockLocationRole: (stockLocationId: string) => StockLocationRole | undefined;
  hasStockLocationRoleInCompany: (companyId: string, role: StockLocationRole, stockLocationId?: string) => boolean;

  // Should become obsolete
  hasStockLocationRole: (companyId: string, stockLocationId: string, role: StockLocationRole) => boolean;
}

const defaultContext: StockLocationRoleAssignmentContextProps = {
  stockLocationRoles: new Map(),
  setStockLocationRoles: () => {},
  stockLocationRolesLoading: true,
  refreshStockLocationRoles: async () => Promise.resolve(),
  currentStockLocationRole: () => undefined,
  hasStockLocationRole: () => false,
  hasStockLocationRoleInCompany: () => false,
};

export const StockLocationRoleAssignmentContext =
  React.createContext<StockLocationRoleAssignmentContextProps>(defaultContext);

interface StockLocationRoleAssignmentState {
  items: Record<string, any>[];
  loading: boolean;
}

export const stockLocationRoleAssignmentSlice = createSlice({
  name: 'stockLocationRoleAssignment',
  initialState: { items: [], loading: true } as StockLocationRoleAssignmentState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<StockLocationRoleAssignment[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<StockLocationRoleAssignment[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
